import React, { Component } from 'react'
import Reflux, { GlobalState } from 'reflux'
import styled from 'styled-components'

import LoopApi from '/helpers/LoopApi'
import Modal from '/components/Modalv2'
import { ModalStore } from '../../../stores/ModalStore'
import { WidgetActions, MainStore } from '../../../stores/MainStore'

export default class ChangePaymentMethodSuccess extends Reflux.Component {
	constructor(props) {
		super(props)

		this.stores = [ModalStore, MainStore]
		this.storeKeys = ['meetingId', 'meeting_name', 'meetingName', 'cb', 'presentation', 'widgets']

		this.Cancel = this.Cancel.bind(this)
	}

	Cancel() {
		this.props.closeModal()
	}

	render() {
		return (
			<Modal closeModal={this.props.closeModal}>
				<Container >
					<Contents>
						<Title className="header">Payment method changed successfully.</Title>
					</Contents>

					<Options>
						<Button className="button default" onClick={this.Cancel}>Ok</Button>
					</Options>
				</Container>
			</Modal>
		)
	}
}

const Container = styled.div`
	padding: 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 420px;
`

const Contents = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
`

const Title = styled.div`
	font-weight: ${props => props.theme.textBold};
	font-size: ${props => props.theme.textLG};
`

const Details = styled.div`
	font-weight: ${props => props.theme.textRegular};
	font-size: ${props => props.theme.textMD};
	padding-top: 10px;
`

const Options = styled.div`
	display: flex;
	width: 70%;
`

const Button = styled.div`
	cursor: pointer;
	display: flex;
	justify-content: center;
	flex: 1;
	padding: 14px;
	margin: 4px;
`
